module.exports = __webpack_public_path__ + "static/media/header_logo.07d9e7c4.webp";